import Accordion from "./Accordion";

export default function CardBigDemo({item, className= '', onClose}) {
    const hasLinks = item.links && item.links.length > 0;
    
    return (
        <div className={`card-big-demo flex flex-row rounded-[3rem] border-[0.25rem] border-[#e2e2e2] bg-[#0E2242] min-h-[76rem] ${className}`}>
            <div className="
            pl-[8.875rem] pr-[7.625rem] pb-[9.75rem] leading-none
            border-r-[0.25rem] border-[#e2e2e2]
            flex flex-col justify-end
            relative
            ">
                <div className="font-light text-[7.5rem] leading-[8.75rem] mb-[4.4375rem]">
                    {item.title}
                </div>
                <div className="font-light text-[3.875rem] leading-[3.875rem] text-[#E2E2E2]">
                    {item.category}
                </div>

                <div className={`absolute
                flex
                w-[10.375rem] h-[10.375rem] rounded-full
                font-normal text-[6.375rem] leading-none
                bg-[#03BCE9]
                justify-center items-center
                left-[8.875rem] top-[8.5rem]`}
                >
                    {item.id}
                </div>

            </div>
            
            <div className="w-full flex flex-col">
                <div className={`mt-[7.75rem] ${item.padding || 'low-padding'}`}>
                    <div className="
                    mb-[2.875rem]
                    text-[2.625rem] font-light leading-[4.25rem] color-[#E2E2E2]"
                    dangerouslySetInnerHTML={{__html:item.description}}
                    ></div>
                    {item.featured && (
                    <div className="mb-[2.625rem] font-normal text-[1.75rem] leading-none text-[#C7C8D3]">
                        {item.featured}
                    </div>
                    )}
                    {item.subcategories && (
                    <div className="font-light text-[3.25rem] leading-[4rem]">
                        {item.subcategories}
                    </div>
                    )}
                </div>
                
                {hasLinks &&
                <div className="
                w-[calc(100%-6.625rem-6.625rem)] ml-[6.625rem]
                bg-[#1F335B]
                border-[0.25rem] border-[#E2E2E2]
                rounded-[2rem]
                flex flex-col gap-[4.5rem]
                pl-[10.5rem] pr-[7.75rem] py-[4.375rem]
                relative
                mt-[auto]
                translate-y-[4rem]
                ">
                    <div className="text-[1.75rem] font-normal leading-none color-[#C7C8D3]
                    absolute top-1/2 left-[-3rem] -translate-y-1/2 -rotate-90 origin-center
                    ">Scan to learn more</div>

                    {item.links.map((link, index) => (
                        <div className="flex flex-row items-center"
                            key={index}>
                                <img
                                    src={`${process.env.PUBLIC_URL}/qr/${link.qr}`}
                                    alt={link.title}
                                    className="w-[12.5rem] h-[12.5rem] object-cover rounded-[1.25rem] mr-[4.125rem]
                                    border-[0.625rem] border-[#D9D9D9]"
                                />
                                <div className="font-normal text-[2.625rem] leading-[3.625rem]">
                                    {link.title}
                                </div>
                        </div>
                    ))}
                    
                </div>
                }
            </div>
            
        </div>
    );
};